/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUpdateResultDto } from './CreateUpdateResultDto';
import {
    CreateUpdateResultDtoFromJSON,
    CreateUpdateResultDtoFromJSONTyped,
    CreateUpdateResultDtoToJSON,
} from './CreateUpdateResultDto';

/**
 * 
 * @export
 * @interface CalculateResultsDto
 */
export interface CalculateResultsDto {
    /**
     * 
     * @type {Array<CreateUpdateResultDto>}
     * @memberof CalculateResultsDto
     */
    results: Array<CreateUpdateResultDto>;
}

/**
 * Check if a given object implements the CalculateResultsDto interface.
 */
export function instanceOfCalculateResultsDto(value: object): value is CalculateResultsDto {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function CalculateResultsDtoFromJSON(json: any): CalculateResultsDto {
    return CalculateResultsDtoFromJSONTyped(json, false);
}

export function CalculateResultsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculateResultsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(CreateUpdateResultDtoFromJSON)),
    };
}

export function CalculateResultsDtoToJSON(value?: CalculateResultsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map(CreateUpdateResultDtoToJSON)),
    };
}

